import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { useSelector } from 'react-redux'
import { getBaseUrl } from '../../Utils'
import { useTitleContext } from "../../Hooks/useTitleContext"

const AdminTasks: React.FC = () => {

    const { setTitle } = useTitleContext();
    setTitle("Admin Tasks");

    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const userPrivileges = currentUserData?.privileges || []
    const hasPrivilege = (task: string) => userPrivileges.includes(task)

    const column1Tasks = [
        { path: `#ManageUsers`, icon: "icon-user", title: "User Accounts", description: "Approve, reject and delete user accounts.", privilege: "AdminTasks_ManageUsers" },
        { path: `#ManageAdminTools`, icon: "icon-play-circle", title: "Admin Procedures", description: "Run frequently used Admin procedures." },
        { path: `#datamapper`, icon: "icon-map", title: "Data Mapping", description: "Add or Edit various data mappings." },
        { path: `#appdimensions`, icon: "icon-box", title: "Manage Dimensions", description: "Add and edit various dimensions." },
        { path: `#BusinessParameters`, icon: "icon-list", title: "Business Parameters", description: "Add, edit and remove business parameters.", privilege: "AllowSecuredBusinessParameter" },
        { path: `#RunSqlQueries`, icon: "icon-layers", title: "Run SQL Queries", description: "Type the Command to run your queries.", privilege: "AdminTasks_RunQuery" },
        { path: `#Log4netConfig`, icon: "icon-feather", title: "Log4net Config", description: "Manage logging configurations.", type:"SystemAdmin" },
        { path: `#DrillThruSetManagement`, icon: "icon-grid", title: "Drill-Thru Set Management", description: "Add/Edit Drill-Thru Sets.", privilege: "CreateDrillThruSet" }
    ]

    const column2Tasks = [
        { path: `#admin/manage-roles`, icon: "icon-users", title: "Manage Roles", description: "Add and remove workspaces, securities, or attributes for roles.", privilege: "AdminTasks_ManageRoleDashboards" },
        { path: `#manageAudit`, icon: "icon-check-square", title: "Activity and Audits", description: "View activity and audits." },
        { path: `#ManageDeployment`, icon: "icon-server", title: "Deployment Management", description: "Pull a build that is already pushed to AWS-S3 by Jenkins.", privilege: "ManageDeployment" },
        { path: `#datasources`, icon: "icon-share-2", title: "Data Sources", description: "Add, edit, remove and monitor data sources." },
        { path: `#AutoTestTool`, icon: "icon-monitor", title: "Report AutoTest", description: "Manage Report AutoTest.", privilege: "AutoTestTool" },
        { path: `#manage-forms-engine`, icon: "icon-file", title: "Forms Engine Configuration", description: "Configure Forms Engine.", privilege: "AllowTools_Foundations" },
        { path: `#FormsEngine?formName=Send_Notification-618&dataObjectId=99`, icon: "icon-arrow-up-right", title: "Send Notification", description: "Send Notification to Users.", privilege: "AllowSendNotification" }
    ]

    return (
        <div className="admin-tasks-container">
            <div className="header w-100 m-auto" style={{ maxWidth: '1106px' }}>
                Admin Tasks
            </div>
            <div className="padding-top-large"></div>
            <div className="padding-top-large"></div>
            <div className="admin-tasks-row m-auto unicorn-flex-row">
                <div className="unicorn-flex-column">
                    {column1Tasks.filter(task =>(!task.privilege || hasPrivilege(task.privilege)) &&
                        (task.title !== 'Log4net Config' || currentUserData?.type === 'SystemAdmin'))
                        .map((task, index) => (
                        <TaskLink key={index} {...task} />
                    ))}
                </div>
                <div className="unicorn-flex-column">
                    {column2Tasks.filter(task => !task.privilege || hasPrivilege(task.privilege)).map((task, index) => (
                        <TaskLink key={index} {...task} />
                    ))}
                </div>
            </div>
        </div>
    )
}

const TaskLink: React.FC<{ path: string; icon: string; title: string; description: string }> = ({
    path,
    icon,
    title,
    description,
}) => {
    const navigate = useNavigate()
    return (
        <div className="admin-tasks-link d-flex flex-row mt-3" onClick={() => navigate(path)}>
            <span className={`admin-tasks-icon feather ${icon}`}></span>
            <span className="admin-tasks-tile">
                <div className="div-link">{title}</div>
                <span className="padding-top-small sub-info">{description}</span>
            </span>
        </div>
    )
}

export default AdminTasks
